import React, { Component } from 'react'
import { Button } from 'hljd'
import Styles from './style.module.less'
import { observer } from 'mobx-react'
import store from '../store'
import storeUp from '../../store'

@observer
export default class extends Component {
  UNSAFE_componentWillMount() {
    store.GetOrderFB('id=' + storeUp.id)
  }
  render() {
    let {
      orderFB: {
        subTime,
        contract_money,
        eat_time,
        hotel_hall,
        price,
        status,
        tables_num,
        wedding_day
      }
    } = store
    let _eat_time = eat_time.split(',')
    _eat_time = _eat_time.map(v => {
      let _arr = []
      if (v == 1) {
        _arr.push('午市')
      } else if (v == 2) {
        _arr.push('晚市')
      } else {
        _arr.push('暂无')
      }

      return _arr.join(',')
    })
    return (
      <div className={Styles.FeedBack}>
        <div className={Styles.cont}>
          <dl>
            <dt>提交时间</dt>
            <dd>{subTime}</dd>
          </dl>
          <dl>
            <dt>审核状态</dt>
            <dd>{status}</dd>
          </dl>
          <div className={Styles.line} />
          <dl>
            <dt>婚期</dt>
            <dd>{wedding_day}</dd>
          </dl>
          <dl>
            <dt>婚宴场地</dt>
            <dd>{hotel_hall.name}</dd>
          </dl>
          <dl>
            <dt>市别</dt>
            <dd>{_eat_time}</dd>
          </dl>
          <dl>
            <dt>婚宴桌数</dt>
            <dd>{tables_num}</dd>
          </dl>
          <dl>
            <dt>每桌预算</dt>
            <dd>{price}</dd>
          </dl>
          <dl>
            <dt>合同金额</dt>
            <dd>{contract_money}</dd>
          </dl>
        </div>
        <div style={{ display: 'none' }} className={Styles.areaBtn}>
          <Button
            style={{ width: 90, marginRight: 8, marginLeft: 13 }}
            type="ghost"
          >
            跟进失败
          </Button>
          <Button style={{ width: 90, marginRight: 8 }} type="ghost">
            定金已付
          </Button>
          <Button style={{ width: 90 }} type="primary">
            确认到店
          </Button>
        </div>
      </div>
    )
  }
}
